import * as React from 'react';
import * as styles from './VideoModalContent.css';

interface IVideoModalContentProps {
  media: React.ReactNode;
  description: React.ReactNode;
}

export function VideoModalContent({ media, description }: IVideoModalContentProps) {
  return (
    <div className={styles['content']}>
      <div className={styles['content__media']}>{media}</div>

      {description && <div className={styles['content__description']}>{description}</div>}
    </div>
  );
}
